import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default'; //   getTargetProperty,

const cfg = {
  policyType: 9,
  policySubType: 0,
  holderType: 2,
  tmDpfilters: {
    dpFileTagEnabled: 1,
    dpFileAction: 109,
    dpFileTagContent: '[ProbableLeakage]',
    dpSecondActionEnabled: 1,
    dpSecondActionType: 6,
  },
};

export function getDlpSalesforceSandboxTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(t, tempConfig, accountEmail, [], []);
}
